import Image from 'next/image'
import Link from 'next/link'

interface HelpOptionCardProps {
  image: string
  title: string
  subtitle?: string
  href: string
}

const HelpOptionCard = ({
  image,
  title,
  subtitle,
  href
}: HelpOptionCardProps) => {
  return (
    <Link
      href={href}
      className="group flex h-full w-full flex-col items-start gap-4 bg-white-500 p-5 transition-colors hover:bg-cream-300 md:p-7"
    >
      <div className="flex w-full items-center justify-between">
        <div className="flex size-10 items-center justify-center md:size-12">
          <Image
            src={image}
            alt={title}
            width={48}
            height={48}
            className="size-10 object-contain md:size-12"
          />
        </div>
        <span
          aria-hidden="true"
          className="font-display text-[20px] text-ink-200 transition-all group-hover:translate-x-1 group-hover:text-blue-500"
        >
          →
        </span>
      </div>

      <h3 className="mt-auto font-display text-[18px] leading-tight font-medium text-ink-700 md:text-[20px]">
        {title}
      </h3>

      {subtitle && (
        <p className="text-[13px] leading-relaxed text-ink-200">{subtitle}</p>
      )}
    </Link>
  )
}

export default HelpOptionCard
